import { simReducer } from './simulationReducer';
import { STEP_SIZE } from '../containers/Onboarding/RetirementAmountNeeded';

const simulationReducer = simReducer('SPENDING_PLAN_', ['distribution']);

const initialState = {
  fetched: false,
  data: null,
  spendingSources: {},
  simulation: undefined,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'SPENDING_PLAN_MODULE_FETCHED':
      if (action.payload) {
        return Object.assign({}, state, { fetched: true, data: action.payload });
      } else {
        return { fetched: true, data: null };
      }
    case 'SPENDING_PLAN_SIMULATION_STARTED':
    case 'SPENDING_PLAN_SIMULATION_FINISHED':
      return Object.assign({}, state, { simulation: simulationReducer(state.simulation, action) });
    case 'SPENDING_PLAN_SPENDING_SOURCES_FETCHED':
      if (action.payload) {
        return Object.assign({}, state, {
          fetched: true,
          spendingSources: Object.assign({}, state.spendingSources, {
            [action.payload.withdrawalRate]: action.payload.data,
          }),
        });
      } else {
        return { fetched: true, data: null };
      }
    case 'CURRENT_AFTER_TAX_INCOME_FETCHED':
      return Object.assign({}, state, {
        data: {
          ...state.data,
          // load a suggested value cents get converted to dollar
          retirement_budget: Math.round(action.payload.initial_take_home_pay / 100 / STEP_SIZE) * STEP_SIZE,
        },
      });
    default:
      return state;
  }
};
